"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#333",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.852 12.996a.4.4 0 0 0 .134.027v-.003a.35.35 0 0 0 .247-.594l-.33-.33a1.11 1.11 0 0 1 0-1.565L13.3 9.134a1.107 1.107 0 0 1 1.566 1.566l-.944.944a.349.349 0 1 0 .493.494l.944-.944a1.805 1.805 0 0 0-2.552-2.553l-1.397 1.397a1.804 1.804 0 0 0 0 2.552l.33.33q.048.05.113.076m-2.48 2.127a1.805 1.805 0 0 0 2.28-.222l1.395-1.396a1.807 1.807 0 0 0 0-2.553l-.31-.31a.35.35 0 1 0-.493.494l.31.31a1.11 1.11 0 0 1 0 1.565l-1.396 1.396a1.134 1.134 0 0 1-1.566 0 1.11 1.11 0 0 1 0-1.565l.936-.936a.348.348 0 1 0-.494-.494l-.935.934a1.805 1.805 0 0 0 .274 2.777",
    clipRule: "evenodd"
  })]
}), 'Link');
//# sourceMappingURL=index.js.map